export default __webpack_public_path__ + "static/media/twitter.6456a4ea.svg";